export default "__VITE_ASSET__CHFzpD79__"